export const Loading = () => {
  return (
    <div id="overlay" style={{ zIndex: 9999 }}>
      <div className="modal-backdrop" id="containerLoader">
        <div className="loader">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div className="imgLoader"></div>
      </div>
    </div>
  );
};
